import type { PosStaffSalesChannel } from '../types';

/**
 * TCR-2429 — BE cap `limit` ở 100 (`StaffListDto`). Mặc định của BE là 20 — quá hẹp cho chi nhánh
 * đông người. Đặt ở file riêng để cả ô chọn nhân viên và bước XÁC THỰC `care_staff_id` của tab
 * B2B dùng đúng một con số (lệch limit là hai bên nhìn thấy hai danh sách khác nhau).
 */
export const POS_STAFF_PAGE_LIMIT = 100;

/**
 * TCR-2429 — key cache danh sách nhân viên POS. Phần `[0..3]` (module + phạm vi) quyết định BỘ
 * DỮ LIỆU, phần cuối chỉ là từ khoá tìm.
 *
 * Tách hàm để `StaffAsyncSelect` và bước xác thực ở `POS/index.tsx` chia sẻ CÙNG một cache:
 * xác thực dùng lại đúng danh sách NVKD mà ô chọn đang hiện, không phát sinh request thứ hai.
 */
export function posStaffQueryKey(params: {
  storeId?: string;
  salesChannel?: PosStaffSalesChannel;
  keyword: string;
}): readonly unknown[] {
  return ['pos', 'staff', params.storeId, params.salesChannel ?? 'store', params.keyword];
}

/** Phần quyết định phạm vi danh sách (mọi thứ trong key trừ từ khoá tìm). */
export function posStaffScopeOf(queryKey: readonly unknown[] | undefined): {
  storeId?: string;
  salesChannel?: PosStaffSalesChannel;
} | null {
  if (!queryKey || queryKey[0] !== 'pos' || queryKey[1] !== 'staff') return null;
  const scope = queryKey[3];
  return {
    storeId: queryKey[2] as string | undefined,
    salesChannel: scope === 'b2b' ? 'b2b' : undefined,
  };
}
